

<template>
  <section class="rank-main">
    <div class="rank-content">
      <h3>
        {{tas_title}}{{ $t('积分排名榜单') }}
        <div class="search-box df">
          <el-input v-model="nameSearch" :placeholder="$t('请输入关键字')" @keyup.enter.native="handleNameSearch" maxlength="20" class="f1"></el-input>
          <el-button type="primary" class="fn" @click="handleNameSearch"><span class="iconfont">&#xe8b9;</span></el-button>
        </div>
      </h3>
      <el-table 
        :data="rankData" 
        stripe>
        <el-table-column
          prop="user_nick_name"
          :label="$t('昵称')"
        >
          <!-- <template slot="header" slot-scope="scope">
            <div class="searchth">
              <span style="margin-right: 10px;">{{ $t('昵称') }}</span>
              <el-input
                v-show="showNameSearch"
                v-model="nameSearch"
                size="mini"
                :placeholder="$t('关键字搜索，按回车确认')"
                @keyup.enter.native="handleNameSearch"
                @clear="handleNameSearch"
                @blur="handleSearchBlur"
                ref="nameSearchInput"
                clearable
              />
              <i 
                v-show="!showNameSearch" 
                class="el-icon-search search-icon" 
                @click="activateSearch"
              ></i>
            </div>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="user_company"
          :label="$t('公司')"
        >
        </el-table-column>
        <el-table-column
          prop="tpsn_score"
          :label="$t('积分')"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="actual_rank"
          :label="$t('排名')"
          width="100"
        ></el-table-column>
      </el-table>
      
      <!-- 添加分页组件 -->
      <div class="pagination-container-wrapper">
        <div class="total">{{ $t("共n项", {num:total}) }}</div>
        <div class="pagination-container">
          <el-pagination            
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { scoreList } from '@/api/challenge';
export default {
  name: "PointsRanking",
  data() {
    return {
      nameSearch: '', // 添加昵称搜索关键字
      showNameSearch: false, // 是否显示昵称搜索
      originalRankData: [], // 保存原始数据
      rankData: [],
      tableHeight: 695, // 表格高度
      currentPage: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      total: 0, // 总条数
      tas_id: 0, // 活动ID
      tas_title: "", // 活动title
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id;
    }
  },
  mounted() {
    this.tas_id = this.$route.query.tas_id; // 获取活动ID
    this.tas_title = this.$route.query.tas_title; // 获取活动title
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
    this.getData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    async getData() {
      const res = await scoreList({
        ta_id: this.ta_id,//344
        tas_id: this.tas_id,//1
        page: this.currentPage,
        paginate: this.pageSize,
        keyword: this.nameSearch,
      });
      if (res.status == 200) {
        this.rankData = this.originalRankData = res.data.data;
        this.total = res.data.total;
      }
    },
    // 计算表格高度
    calculateTableHeight() {
      this.tableHeight = window.innerHeight - 250; // 根据实际情况调整减去的值
    },
    // 处理每页显示条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    // 激活搜索框
    activateSearch() {
      this.showNameSearch = true;
      this.$nextTick(() => {
        this.$refs.nameSearchInput.focus();
      });
    },
    // 处理搜索框失焦
    handleSearchBlur() {
      // 如果搜索框为空，则隐藏搜索框
      if (!this.nameSearch) {
        this.showNameSearch = false;
      }
    },
    // 处理昵称搜索
    handleNameSearch() {
      this.currentPage = 1; // 重置页码为1
      this.getData(); // 重新获取数据
    },
  },
};
</script>
<style lang="scss" scoped>
  .rank-main{
    padding: 80px 120px 20px;
    // height: calc(100vh - 0px);
    background: #F9F9F9;
  }
  .rank-content{
    min-width: 1200px;
    max-width: 1680px;
    min-height: calc(100vh - 380px);
    margin: 0 auto;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 10%);
    padding: 40px;
    >h3{
      font-size: 16px;
      font-weight: 600;
      color: #000;
      line-height: 28px;
      margin-bottom: 16px;
      letter-spacing: 1px;
      display: flex;
      justify-content: space-between;
      .search-box {
        width: 240px;
        height: 36px;
        padding: 0 16px;
        border: 1px solid rgb(223, 223, 223);
        border-radius: 50px;
        background: rgba(255, 255, 255, 0.39);
        ::v-deep .el-input__inner{
          height: 34px !important;
          border: none;
          color: #191919;
          padding: 0;
        }
        .el-button--primary {
          border: none;
          outline: none;
          font-size: 16px;
          background-color: transparent;
          color: rgb(105, 105, 105);
          padding: 0;
          margin: 0;
        }

      }
    }
    .searchth{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      span{
        flex-shrink: 0;
      }
      .el-input{
        width: calc(100% - 200px);
      }
    }
    .el-table{
      width: 100%;
      // height: calc(100% - 160px);
      // 添加表格样式
      ::v-deep .el-table__header-wrapper th {
        background-color: #F5F7FA;
        color: #191919;
        font-weight: 500;
        padding: 6px 0;
        .cell{
          position: relative;
          min-height: 28px;
          .search-icon{
            cursor: pointer;
            color: #4D4D4D;
          }
          &.cell::after{ 
            content: '';
            display: block;
            width: 1px;
            height: 16px;
            background-color: #DFDFDF;
            position: absolute;
            right: 0;
            top: 6px;
          }
        }
        
        // 第四列不显示边框
        &:nth-child(4){
          .cell::after{
            display: none;
          }
        }
      }
      ::v-deep .el-table__row {
        height: 40px;
        td {
          color: #191919;
          padding: 6px 0;
        }
      }
      ::v-deep .cell {
        min-height: 28px;

        display: flex;
        align-items: center;
        width: 100%;
      }
    }
    // 添加分页样式
    .pagination-container-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .total{
        font-size: 12px;
        color: #191919;
      }
      .pagination-container {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
    }
    ::v-deep .el-pager li.active {
      background-color: #E6F1FD;
      color: #0067D1;
    }
    ::v-deep .el-pager li:hover {
      color: #0067D1;
    }
    ::v-deep .el-select .el-input.is-focus .el-input__inner,::v-deep .el-input__inner:focus,::v-deep .el-input__inner:hover {
      border-color: #0067D1;
    }
    ::v-deep .el-tabs__item.is-active,
    ::v-deep .el-pagination .btn-next:hover,
    ::v-deep .el-pagination .btn-prev:hover{
      color: #0067D1;
    }
  }
</style>